import{AuthContext}from"../providers/authProvider";import{useContext}from"react";export var useAuth=function useAuth(){return useContext(AuthContext);};